export const black = '#000';
export const blue = {
    100: '#E7F0FB',
    300: '#9CC9F6',
    500: '#3A94ED',
    700: '#015AC8',
    900: '#083093',
};
export const green = {
    100: '#E6F3EE',
    500: '#A3EA3F',
    700: '#00A878',
    800: '#027854',
};
export const grey = {
    50: '#F6F7F8',
    100: '#F3F4F6',
    200: '#E6E8EA',
    300: '#CCD1D6',
    400: '#B3BAC1',
    500: '#808B98',
    600: '#667483',
    700: '#505D6D',
    800: '#33465A',
    900: '#172C42',
};
export const latte = {
    50: '#FBF3EC',
    100: '#FFF1EB',
};
export const lavender = {
    100: '#E8EAFC',
};
export const navy = {
    200: '#CEE0F3',
    600: '#3B71AA',
    700: '#2E5884',
    800: '#213F5F',
    900: '#172C42',
};
export const pink = {
    100: '#FAEDF5',
    500: '#FF9EC5',
};
export const purple = {
    100: '#F5E8FD',
};
export const red = {
    100: '#FCE9E7',
    200: '#FBD4D0',
    400: '#F38172',
    500: '#EF5844',
    800: '#CF230C',
};
export const yellow = {
    100: '#FFF3C2',
    200: '#FFE786',
    500: '#FFCF0D',
    600: '#FFC300',
    800: '#FFA30F',
};
export const white = '#FFF';
export const transparent = 'rgba(0,0,0, 0)';
//# sourceMappingURL=data:application/json;base64,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